<template>
  <div class="footer">
    <footer>©{{ logo_name }} Technology. All Rights Reserved.</footer>
    <!-- <footer>https://www.hunt-love.com/ belongs to PROMETHEUS HIGH TECHNOLOGY PTE. LTD.</footer> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo_name: "",
    };
  },
  created() {
    this.renderUI();
  },
  methods: {
    renderUI() {
      const config = this.$store.state.data;
      this.logo_name = config.logo_name;
    },
  },
};
</script>

<style lang="less" scoped>
footer {
  // position: fixed;
  // bottom: 0px;
  width: 100%;
  background: #000;
  text-align: center;
  font-size: 13px;
  font-family: Poppins, PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #767070;
  padding: 20px 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #2e2d2d;
}
</style>
